import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: ${(props) => props.theme.global.BackgroundColorThemeHome1};
  color: ${(props) => props.theme.global.BackgroundInside};
`;
